import { datadogRum } from '@datadog/browser-rum';

export const initializeDatadog = async (
  datadogRumApplicationId?: string,
  datadogRumClientToken?: string,
  env?: string
) => {
  const shouldInitializeDataDog =
    datadogRumApplicationId && datadogRumClientToken && env;
  const serviceName =
    env === 'prod' ? 'literacy-platform-prod' : 'literacy-platform-nonprod';
  if (shouldInitializeDataDog) {
    datadogRum.init({
      applicationId: datadogRumApplicationId,
      clientToken: datadogRumClientToken,
      site: 'datadoghq.com',
      service: serviceName,
      env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      // the following line is to serve as a reminder for the future for APM tracing.
      // allowedTracingUrls: [],
      defaultPrivacyLevel: 'mask',
    });
  } else {
    console.error('Datadog failed to initialize.');
  }
};
